module.exports = __webpack_public_path__ + "static/media/curve-3crv.0685ad92.png";